import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import JBIFrameHolder from 'components/essentials/JBIFrameHolder';
import FinancingCtaButton from 'components/essentials/FinancingCtaButton';
import PDPOrderSwatchesSidebar from 'components/consumer/PDP/PDPOrderSwatchesSidebar';
import CtaButton from 'components/essentials/Cta/CtaButton';
import CtaLink from 'components/essentials/Cta/CtaLink';
const ToggleCTALinkButton = props => {
  const $ = _c(37);
  const {
    toggleInputType,
    style: t0,
    isHovered,
    linkClassName
  } = props;
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const style = t1;
  let t2;
  if ($[2] !== toggleInputType) {
    t2 = toggleInputType?.selected?.value ? toggleInputType.selected.value?.replace(" ", "") : "";
    $[2] = toggleInputType;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const CTAComponentType = t2;
  const [iFrameVisibility, setiFrameVisibility] = useState(false);
  const [isOrderSwatchesSidebarOpen, setIsOrderSwatchesSidebarOpen] = useState(false);
  let t3;
  if ($[4] !== CTAComponentType || $[5] !== toggleInputType) {
    t3 = () => {
      if (toggleInputType && toggleInputType.selected && CTAComponentType === "CTAButton") {
        if (toggleInputType.ctaButton.embedCode.enabled && toggleInputType.ctaButton.embedCode.value.includes("<a ")) {
          return true;
        }
      }
      return false;
    };
    $[4] = CTAComponentType;
    $[5] = toggleInputType;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const [isButtonEmbedded] = useState(t3);
  let finalCTAButton = null;
  if (toggleInputType && toggleInputType.selected && CTAComponentType === "CTAButton" && toggleInputType.ctaButton) {
    if (toggleInputType.ctaButton.type && (toggleInputType.ctaButton.type === "Affirm" || toggleInputType.ctaButton.type === "Financing")) {
      const t4 = toggleInputType.ctaButton.color || "black";
      const t5 = toggleInputType.ctaButton.style || "solid-button";
      let t6;
      if ($[7] !== style || $[8] !== t4 || $[9] !== t5 || $[10] !== toggleInputType.ctaButton.content) {
        t6 = <FinancingCtaButton style={style} color={t4} styling={t5}>{toggleInputType.ctaButton.content}</FinancingCtaButton>;
        $[7] = style;
        $[8] = t4;
        $[9] = t5;
        $[10] = toggleInputType.ctaButton.content;
        $[11] = t6;
      } else {
        t6 = $[11];
      }
      finalCTAButton = t6;
    } else {
      let t4;
      if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = () => {
          setIsOrderSwatchesSidebarOpen(true);
        };
        $[12] = t4;
      } else {
        t4 = $[12];
      }
      const t5 = toggleInputType.ctaButton.color || "black";
      const t6 = toggleInputType.ctaButton.style || "solid-button";
      let t7;
      if ($[13] !== isHovered || $[14] !== style || $[15] !== t5 || $[16] !== t6 || $[17] !== toggleInputType.ctaButton.content) {
        t7 = <CtaButton onClick={t4} color={t5} styling={t6} style={style} isHovered={isHovered} className="!block !m-0">{toggleInputType.ctaButton.content}</CtaButton>;
        $[13] = isHovered;
        $[14] = style;
        $[15] = t5;
        $[16] = t6;
        $[17] = toggleInputType.ctaButton.content;
        $[18] = t7;
      } else {
        t7 = $[18];
      }
      finalCTAButton = t7;
    }
  }
  let t4;
  if ($[19] !== isOrderSwatchesSidebarOpen) {
    t4 = isOrderSwatchesSidebarOpen && <PDPOrderSwatchesSidebar show={isOrderSwatchesSidebarOpen} onClose={() => {
      setIsOrderSwatchesSidebarOpen(false);
    }} closeSlidePanel={() => {
      setIsOrderSwatchesSidebarOpen(false);
    }} />;
    $[19] = isOrderSwatchesSidebarOpen;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  let t5;
  if ($[21] !== CTAComponentType || $[22] !== isHovered || $[23] !== linkClassName || $[24] !== style || $[25] !== toggleInputType) {
    t5 = toggleInputType && toggleInputType.selected && CTAComponentType === "CTALink" && !!toggleInputType.ctaLink && toggleInputType.ctaLink.content && <CtaLink to={toggleInputType.ctaLink.linkTo} color={toggleInputType.ctaLink.color} styling={toggleInputType.ctaLink.style || "solid-button"} style={style} isHovered={isHovered} className={`!block !m-0 ${linkClassName}`}>{toggleInputType.ctaLink.content}</CtaLink>;
    $[21] = CTAComponentType;
    $[22] = isHovered;
    $[23] = linkClassName;
    $[24] = style;
    $[25] = toggleInputType;
    $[26] = t5;
  } else {
    t5 = $[26];
  }
  let t6;
  if ($[27] !== CTAComponentType || $[28] !== finalCTAButton || $[29] !== iFrameVisibility || $[30] !== isButtonEmbedded || $[31] !== toggleInputType) {
    t6 = toggleInputType && toggleInputType.selected && CTAComponentType === "CTAButton" && !!toggleInputType.ctaButton && toggleInputType.ctaButton.content && <div>{toggleInputType.ctaButton.embedCode.enabled && isButtonEmbedded && <div className="embed-button" dangerouslySetInnerHTML={{
        __html: toggleInputType.ctaButton.embedCode.value
      }} />}{toggleInputType.ctaButton.embedCode.enabled && !isButtonEmbedded && iFrameVisibility && <JBIFrameHolder isOpen={iFrameVisibility} onClose={setiFrameVisibility} script={toggleInputType.ctaButton.embedCode.value || ""} />}{!isButtonEmbedded && finalCTAButton}</div>;
    $[27] = CTAComponentType;
    $[28] = finalCTAButton;
    $[29] = iFrameVisibility;
    $[30] = isButtonEmbedded;
    $[31] = toggleInputType;
    $[32] = t6;
  } else {
    t6 = $[32];
  }
  let t7;
  if ($[33] !== t4 || $[34] !== t5 || $[35] !== t6) {
    t7 = <>{t4}{t5}{t6}</>;
    $[33] = t4;
    $[34] = t5;
    $[35] = t6;
    $[36] = t7;
  } else {
    t7 = $[36];
  }
  return t7;
};
ToggleCTALinkButton.propTypes = {
  toggleInputType: PropTypes.shape({
    selected: PropTypes.shape({
      value: PropTypes.string
    }),
    ctaButton: PropTypes.shape({
      content: PropTypes.string,
      embedCode: PropTypes.shape({
        enabled: PropTypes.bool,
        value: PropTypes.string
      }),
      type: PropTypes.string,
      color: PropTypes.string,
      style: PropTypes.string
    }),
    ctaLink: PropTypes.shape({
      content: PropTypes.string,
      linkTo: PropTypes.string,
      color: PropTypes.string,
      style: PropTypes.string
    })
  }),
  style: PropTypes.shape({
    height: PropTypes.string,
    width: PropTypes.string
  }),
  isHovered: PropTypes.bool,
  linkClassName: PropTypes.string
};
export default withRouter(ToggleCTALinkButton);